import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'

import { KTIcon } from '../../../../../_metronic/helpers'
import { RowKebabMenu } from '../../../../common/RowKebabMenu'
import { ResendCallbackButton } from '../common/ResendCallbackButton'

interface Props {
  ticketToken: string
  canResend: boolean
  canReplaceRequisite: boolean
  onReplaceRequisite: () => void
}

/**
 * Меню действий строки активной выплаты.
 *
 * Тот же принцип, что у строки пополнения ({@link ActivePaymentTicketRowMenu}): частые операции
 * очереди — виртуальный платёж и отмена тикета — остаются кнопками в строке, а редкие уезжают под
 * «⋮», иначе действия начинают теснить данные.
 *
 * Меню не рендерится вовсе, если ни один пункт недоступен: пустая «⋮» обещает действия, которых нет.
 */
export const ActivePayoutTicketRowMenu: React.FC<Props> = ({
  ticketToken,
  canResend,
  canReplaceRequisite,
  onReplaceRequisite,
}) => {
  const [show, setShow] = useState(false)

  if (!canResend && !canReplaceRequisite) {
    return null
  }

  return (
    <RowKebabMenu title='Действия по выплате' show={show} onToggle={setShow}>
      {canReplaceRequisite && (
        <Dropdown.Item
          as='button'
          type='button'
          className='d-flex align-items-center'
          onClick={onReplaceRequisite}
        >
          <KTIcon iconName='pencil' className='fs-3 me-2' />
          Изменить реквизит
        </Dropdown.Item>
      )}
      {canResend && (
        // ResendCallbackButton гасит всплытие внутри себя, поэтому клик по нему не долетает до
        // штатного автозакрытия меню. Ловим в фазе перехвата — она отрабатывает до обработчика
        // кнопки и на stopPropagation не завязана.
        <div onClickCapture={() => setShow(false)}>
          <ResendCallbackButton
            token={ticketToken}
            className='dropdown-item d-flex align-items-center'
            label='Отправить КБ'
          />
        </div>
      )}
    </RowKebabMenu>
  )
}

export default ActivePayoutTicketRowMenu
